import { Text, View } from "@react-pdf/renderer";

import { Attribution } from "~/common/components";
import { getPdfPatientInformationFromPatient } from "~/providers/components/pdf/utils";
import { PatientData } from "~/providers/utils";
import { BasicPatientInformation } from "~/providers/utils/types/consultation";
import { NoteFeed } from "~/providers/utils/types/patientFeeds";
import { PdfDocument, PdfPatientInformationCard } from "../shared";
import { styles } from "../styles";

interface NoteFeedExportDocumentProps {
  patient: PatientData;
  noteFeed: NoteFeed;
  basicPatientInformation?: BasicPatientInformation | null;
}

export const NoteFeedExportDocument = ({
  patient,
  noteFeed,
  basicPatientInformation,
}: NoteFeedExportDocumentProps) => {
  const patientInformation = getPdfPatientInformationFromPatient(
    patient,
    basicPatientInformation,
  );

  return (
    <PdfDocument
      documentTitle="Progress note"
      headerTitle={`Progress note for ${patientInformation.nameWithAge}`}
    >
      <View style={[styles.section, styles.tight]}>
        <Text style={[styles.h1, { color: "#2433A8", marginBottom: 4 }]}>
          Progress note
        </Text>
        <Text>
          <Attribution
            firstName={noteFeed.generated_by_name}
            date={noteFeed.created_at}
            verb="Created"
          />
        </Text>
      </View>

      <PdfPatientInformationCard {...patientInformation} />

      <View style={[styles.section, styles.tight]}>
        <Text>{noteFeed.context.note}</Text>
      </View>
    </PdfDocument>
  );
};
